<template>
  <div class="language-selector">
    <!-- TEMPORARILY COMMENTED OUT: Rewards display causes 500 errors in production
    <div class="user-rewards-info" v-if="account?.email">
      <span class="user-rewards-points">
        <span class="icon icon-gift"></span>
        {{ formattedPoints }} pts
      </span>
      <span class="user-rewards-separator">•</span>
      <span class="user-rewards-tier" :class="`tier-${tier.toLowerCase()}`">
        {{ capitalizedTier }} Member
      </span>
    </div>
    -->
    <div class="locales-selector" ref="localesDropdown">
      <div style="display: flex; align-items: center" @click="toggleDropdown">
        <div class="user-account-avatar">
          <span>{{avatar}}</span>
        </div>
        <span class="pl-1 pr-1" v-if="account?.first_name">{{account?.first_name}}</span>
        <span class="icon icon-chevron-down" style="font-weight:bold;"></span>
      </div>
      <div class="locales-dropdown p-overlaypanel" v-if="dropdown">
        <div class="user-dropdown-list">
          <div class="user-dropdown-list__item" @click="redirectToBookings">
            <div class="user-dropdown-list__item-icon">
              <img src="/icons/calendar.svg" alt="user"/>
            </div>
            <span>My Bookings</span>
          </div>
          <div class="user-dropdown-list__item" @click="redirectToProfile">
            <div class="user-dropdown-list__item-icon">
              <img src="/icons/user.svg" alt="user"/>
            </div>
            <span>My Account</span>
          </div>
          <div class="user-dropdown-list--separator"></div>
          <div class="user-dropdown-list__item sign-out-user" @click="logOut">
            <div class="user-dropdown-list__item-icon">
              <img src="/icons/exit.svg" alt="exit"/>
            </div>
            <span>Sign out</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useAccountStore } from "~/store/account";
import { useRouter } from "vue-router";
import Cookies from 'js-cookie'
// TEMPORARILY COMMENTED OUT: Rewards causes 500 errors in production
// import { useRewards } from "~/composables/useRewards";

const accountStore = useAccountStore();
const account = computed(() => accountStore.account);
const router = useRouter();
const localePath = useLocalePath()

// TEMPORARILY COMMENTED OUT: Rewards causes 500 errors in production
// const { rewardsBalance, tier, fetchBalance } = useRewards()

const avatar = computed(() => {
  const str = account.value?.first_name ||account.value?.email
  return str ? str.substring(0, 1) : ''
})

// TEMPORARILY COMMENTED OUT: Rewards causes 500 errors in production
// const formattedPoints = computed(() => {
//   return rewardsBalance.value?.toLocaleString() || '0'
// })

// const capitalizedTier = computed(() => {
//   return tier.value.charAt(0).toUpperCase() + tier.value.slice(1)
// })

const dropdown = ref(false)
const localesDropdown = ref<HTMLElement | null>(null)


function toggleDropdown() {
  dropdown.value = !dropdown.value
}

function handleClickOutside(e: Event) {
  const langDropdown = localesDropdown.value;
  if (e.target instanceof Element && langDropdown && !langDropdown.contains(e.target)) {
    dropdown.value = false;
  }
}

const redirectToProfile = () => {
  dropdown.value = false;
  router.push(localePath("/profile/account"));
}

const redirectToBookings = async () => {
  dropdown.value = false;
  router.push(localePath("/profile/trips"));
}

function logOut() {
  dropdown.value = false;
  Cookies.remove("auth");
  accountStore.setAccount(null);
  router.push(localePath("/"));
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
  // TEMPORARILY COMMENTED OUT: Rewards causes 500 errors in production
  // Fetch rewards balance when component mounts
  // if (account.value?.email) {
  //   fetchBalance();
  // }
})

// TEMPORARILY COMMENTED OUT: Rewards causes 500 errors in production
// watch(() => account.value?.email, (newEmail) => {
//   if (newEmail) {
//     fetchBalance();
//   }
// })
</script>

<style lang="scss" scoped>
.language-selector {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}

.user-rewards-info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 12px;
  background: var(--blue-highlight);
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  
  @media screen and (max-width: 900px) {
    display: none;
  }
}

.user-rewards-points {
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--blue);
  
  .icon {
    font-size: 14px;
  }
}

.user-rewards-separator {
  color: var(--grey);
  font-weight: 400;
}

.user-rewards-tier {
  font-weight: 600;
  
  &.tier-bronze {
    color: #CD7F32;
  }
  
  &.tier-silver {
    color: #C0C0C0;
  }
  
  &.tier-gold {
    color: #FFD700;
  }
  
  &.tier-platinum {
    color: #E5E4E2;
  }
}

.locales-selector {
  position: relative;
}
.locales-dropdown {
  position: absolute;
  right: 0;
  top: 100%;
  z-index: 1100;

  @media screen and (max-width: 768px) {
    left: 0;
    right: auto;
  }
}

.user-account-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #E1EFFF;
  margin-right: 4px;

  span {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0;
    text-align: center;
    color: #1985F9;
    text-transform: uppercase;
  }
}

.user-dropdown-list {
  padding: 10px;

  &--separator {
    height: 1px;
    background-color: var(--blue-highlight);
    margin: 8px 0;
  }

  &__item {
    display: flex;
    align-items: center;
    width: 238px;
    height: 44px;
    gap: 8px;
    border-radius: 8px;
    padding: 10px 16px;

    &.sign-out-user {
      color: #E20E0E
    }

    &:hover {
      background-color: var(--blue-highlight);
    }
  }
}
</style>
